import React from "react";
import {
  Paper,
  Typography,
  List,
  ListItem,
  ListItemText,
  IconButton,
} from "@mui/material";
import { DragIndicator } from "@mui/icons-material";

interface Rule {
  id: number | string;
  name: string;
  rules_meta: any;
  ranking: number;
}

interface RulesRankingListProps {
  overlappingRules: Rule[];
  currentRuleId: number | null;
  draggedIndex: number | null;
  onDragStart: (index: number) => void;
  onDragOver: (e: React.DragEvent, index: number) => void;
  onDrop: (e: React.DragEvent, index: number) => void;
  onDragEnd: () => void;
  viewMode: boolean;
}

export const RulesRankingList: React.FC<RulesRankingListProps> = ({
  overlappingRules,
  currentRuleId,
  draggedIndex,
  onDragStart,
  onDragOver,
  onDrop,
  onDragEnd,
  viewMode,
}) => {
  if (viewMode || overlappingRules.length === 0) return null;

  return (
    <Paper
      sx={{
        p: 3,
        mb: 3,
        position: "sticky",
        top: 20,
        maxHeight: "calc(100vh - 40px)",
        overflowY: "auto",
      }}
      elevation={1}
    >
      <Typography variant="h6" sx={{ mb: 2, fontWeight: 600, color: "#91278F" }}>
        Rules Ranking (Drag to reorder)
      </Typography>
      <List>
        {overlappingRules.sort((a, b) => a.ranking - b.ranking).map((rule, index) => {
          const isCurrentRule = currentRuleId
            ? rule.id === currentRuleId
            : rule.id === "new_rule";

          return (
            <ListItem
              key={rule.id}
              draggable
              onDragStart={() => onDragStart(index)}
              onDragOver={(e) => onDragOver(e, index)}
              onDrop={(e) => onDrop(e, index)}
              onDragEnd={onDragEnd}
              sx={{
                cursor: "move",
                border: isCurrentRule ? "2px solid #91278F" : "1px solid #e0e0e0",
                borderRadius: 1,
                mb: 1,
                backgroundColor:
                  draggedIndex === index
                    ? "#f5f5f5"
                    : isCurrentRule
                    ? "#f3e5f5"
                    : "white",
                "&:hover": {
                  backgroundColor: "#f9f9f9",
                },
              }}
            >
              <IconButton sx={{ cursor: "grab", mr: 1 }} disableRipple>
                <DragIndicator />
              </IconButton>
              <ListItemText
                primary={
                  isCurrentRule
                    ? currentRuleId
                      ? `${rule.name} (Current)`
                      : "New Rule (Current)"
                    : rule.name
                }
                secondary={`Ranking: ${rule.ranking}`}
                primaryTypographyProps={{
                  fontWeight: isCurrentRule ? 600 : 400,
                  color: isCurrentRule ? "#91278F" : "inherit",
                }}
              />
            </ListItem>
          );
        })}
      </List>
    </Paper>
  );
};

